var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tooltip',{attrs:{"placement":"right"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('img',{staticStyle:{"width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"src":_vm.screenshotUrl}})]),_c('div',{style:(_vm.spanStyle)},[_c('span',[_vm._v(_vm._s(_vm.url))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }